import About from '../components/about/About'
import Card from '../components/card/Card'
import { Maragogi } from '../components/home/Maragogi'
import Parallax from '../components/parallax/parallax'
import Swiper from '../components/slider/Swiper'
import Wpp from '../components/wpp/Wpp'
import type { Route } from './+types'

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Pousada a beira de Barra Grande, Maragogi - Beach Point Maragogi" },
    { name: "description", content: "Pousada a beira mar de Barra Grande, em Maragogi, com café da manhã incluso" },
  ];
}

export default function index() {
  return (
    <>
      <Swiper />
      <Maragogi />
      <div className="flex flex-wrap justify-center my-10">
        <Card title="Pousada a beira mar de Barra Grande, em Maragogi" image="/04.jpg" href="/a-pousada" /> 
        <Card title="Quartos confortáveis, com ar, chuveiro quente e wi-fi" image="/06.jpg" href="/acomodacoes" />
        <Card title="Café da manhã saboroso e feito na hora" image="/02.jpg" href="/a-pousada" />
      </div>
      <Parallax />
      <About></About>
      <Wpp></Wpp>
    </>
  )
}
